import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M5 12H19M12 9.5V3M8.5 6L12 3L15.5 6M12 14.5V21M8.5 18L12 21L15.5 18" />
	</SVG>
);
